import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import { registerView } from "@frui.ts/views/dist";
import BankExportListView from "../bankExportListView";
import DistributorRefundExportsListViewModel from "../../../../viewModels/finance/bankExports/distributorRefundExports/distributorRefundExportsListViewModel";

const DistributorRefundExportsListView: ViewComponent<DistributorRefundExportsListViewModel> = observer(({ vm }) => {
  return <BankExportListView vm={vm} />;
});

registerView(DistributorRefundExportsListView, DistributorRefundExportsListViewModel);
